var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "dd-2fa-modal",
        transition: "nice-modal-fade",
        classes: "dd-2fa-modal-class",
        "min-width": 360,
        "min-height": 360,
        adaptive: true,
        scrollable: true,
        width: "520px",
        height: "auto",
        reset: false,
        "click-to-close": false,
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose },
    },
    [
      _c("div", { staticClass: "dd-2fa-content" }, [
        _c(
          "button",
          { staticClass: "dd-2fa-close-btn", on: { click: _vm.closeModal } },
          [_c("i", { staticClass: "fa fa-times" })]
        ),
        _vm._v(" "),
        _c("h2", [
          _c("i", { staticClass: "fa fa-mobile" }),
          _vm._v(" " + _vm._s(_vm.title[_vm.getCurrentLocale]) + "\n        "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "dd-2fa-subtitle" }, [
          _vm._v(_vm._s(_vm.subtitle[_vm.getCurrentLocale])),
        ]),
        _vm._v(" "),
        _vm.pinError
          ? _c("p", { staticClass: "dd-2fa-helper dd-2fa-helper--error" }, [
              _c("i", { staticClass: "fa fa-exclamation-circle" }),
              _vm._v(" " + _vm._s(_vm.pinError) + "\n        "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dd-2fa-step-card",
            class: {
              "dd-2fa-step-card--active": !_vm.pinSent,
              "dd-2fa-step-card--done": _vm.pinSent,
            },
          },
          [
            _c("div", { staticClass: "dd-2fa-step-card-header" }, [
              _c("div", { staticClass: "dd-2fa-step-title" }, [
                _c(
                  "span",
                  { staticClass: "dd-2fa-step-number" },
                  [
                    _vm.pinSent
                      ? _c("i", { staticClass: "fa fa-check" })
                      : [_vm._v("1")],
                  ],
                  2
                ),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.stepSendTitle[_vm.getCurrentLocale]) +
                    "\n                    "
                ),
                !_vm.pinSent
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "dd-2fa-step-badge dd-2fa-step-badge--active",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.stepActiveLabel[_vm.getCurrentLocale]) +
                            "\n                    "
                        ),
                      ]
                    )
                  : _c(
                      "span",
                      {
                        staticClass:
                          "dd-2fa-step-badge dd-2fa-step-badge--done",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.stepDoneLabel[_vm.getCurrentLocale]) +
                            "\n                    "
                        ),
                      ]
                    ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "dd-2fa-step-card__required" }, [
                _vm._v(_vm._s(_vm.stepRequiredLabel[_vm.getCurrentLocale])),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.phoneLabel[_vm.getCurrentLocale])),
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "input-text full-width dd-2fa-phone-input",
                attrs: {
                  type: "tel",
                  inputmode: "tel",
                  autocomplete: "tel",
                  placeholder: _vm.phonePlaceholder[_vm.getCurrentLocale],
                },
                domProps: { value: _vm.phoneValue },
                on: { input: _vm.onPhoneInput },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "dd-2fa-phone-hint" }, [
                _vm._v(_vm._s(_vm.phoneHint[_vm.getCurrentLocale])),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dd-2fa-send-row" }, [
              _c(
                "button",
                {
                  staticClass: "button btn-medium dd-2fa-send-btn",
                  attrs: {
                    disabled: _vm.isSending || _vm.resendCooldownSeconds > 0,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.sendSmsCode($event)
                    },
                  },
                },
                [
                  _vm.resendCooldownSeconds > 0
                    ? [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.resendCooldownLabel[
                                _vm.getCurrentLocale
                              ].replace("{seconds}", _vm.resendCooldownSeconds)
                            ) +
                            "\n                    "
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.pinSent
                                ? _vm.resendCode[_vm.getCurrentLocale]
                                : _vm.sendCode[_vm.getCurrentLocale]
                            ) +
                            "\n                    "
                        ),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _vm.pinSent && _vm.resendCooldownSeconds === 0
                ? _c("span", { staticClass: "dd-2fa-status" }, [
                    _c("i", { staticClass: "fa fa-check-circle" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.codeSent[_vm.getCurrentLocale]) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dd-2fa-step-card",
            class: {
              "dd-2fa-step-card--active": _vm.pinSent,
              "dd-2fa-step-card--disabled": !_vm.pinSent,
            },
          },
          [
            _c("div", { staticClass: "dd-2fa-step-card-header" }, [
              _c("div", { staticClass: "dd-2fa-step-title" }, [
                _c("span", { staticClass: "dd-2fa-step-number" }, [
                  _vm._v("2"),
                ]),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.stepPinTitle[_vm.getCurrentLocale]) +
                    "\n                    "
                ),
                !_vm.pinSent
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "dd-2fa-step-badge dd-2fa-step-badge--locked",
                      },
                      [
                        _c("i", { staticClass: "fa fa-lock" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.stepLockedLabel[_vm.getCurrentLocale]) +
                            "\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "dd-2fa-step-card__required" }, [
                _vm._v(_vm._s(_vm.stepRequiredLabel[_vm.getCurrentLocale])),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group dd-2fa-pin-group" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.pinLabel[_vm.getCurrentLocale])),
                ]),
                _vm._v(" "),
                _c("pin-code-input", {
                  ref: "pinInput",
                  attrs: {
                    disabled: !_vm.pinSent,
                    "digit-label": _vm.pinDigitLabel[_vm.getCurrentLocale],
                  },
                  model: {
                    value: _vm.pinValue,
                    callback: function ($$v) {
                      _vm.pinValue = $$v
                    },
                    expression: "pinValue",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.pinSent
              ? _c("p", { staticClass: "dd-2fa-helper" }, [
                  _c("i", { staticClass: "fa fa-info-circle" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.stepPinHelper[_vm.getCurrentLocale]) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pinSent && !_vm.pinComplete
              ? _c("p", { staticClass: "dd-2fa-helper" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.stepPinFormatHint[_vm.getCurrentLocale]) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pinSent && _vm.pinComplete
              ? _c("label", { staticClass: "dd-2fa-pin-confirm" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pinConfirmed,
                        expression: "pinConfirmed",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.pinConfirmed)
                        ? _vm._i(_vm.pinConfirmed, null) > -1
                        : _vm.pinConfirmed,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.pinConfirmed,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.pinConfirmed = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.pinConfirmed = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.pinConfirmed = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.pinConfirmLabel[_vm.getCurrentLocale])),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dd-2fa-actions" }, [
          _c(
            "a",
            {
              staticClass: "dd-2fa-cancel-btn uppercase",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.closeModal($event)
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.cancel[_vm.getCurrentLocale]) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button btn-medium uppercase dd-2fa-confirm-btn",
              attrs: { disabled: !_vm.canConfirmPin },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.confirmPin($event)
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.confirm[_vm.getCurrentLocale]) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }